export class DeudaGraciaPendiente {
	public id?: string;
	public emisorId: string;
	public planUsuarioId: string;
	public nombrePlan: string;
	public fechaVencimientoPlan: Date;
	public fechaFinGracia: Date;
	public cantidadDtes: number;
	public cantidadBhes: number;
	public precioMensualBase: number;
	public montoNeto: number;
	public montoIva: number;
	public montoTotal: number;
	public estado: number;
	public tieneDeuda: boolean;
	public ventanaEnCurso: boolean;
	public fechaPago?: Date;
}
